import { compose, includes, pathOr, prop } from 'ramda';
import { createSelector } from 'reselect';

import { codelists } from 'constants/codelists';
import fetch from 'features/common/fetch';
import { subheaders } from 'features/common/Subheader/constants';
import { getVisibleStateById } from 'features/common/Subheader/selectors';
import { getCodelistByName } from 'utils/codelists';

import { NAME, QUICK_FILTER_STATES } from './constants';
import { getTaskTypesIds } from './utils';

const getRoot = prop(NAME);

const getFilter = compose(prop('filter'), getRoot);

const getTaskTypeList = compose(prop('tasksList'), getFilter);

const getFetchState = (state) => fetch.selectors.getFetchState(fetch.constants.urls.taskOverview)(state);

export const getNoFoundTasks = compose(prop('noFoundTasks'), getFilter);

export const getQuickFilterState = compose(prop('quickFilterType'), getRoot);

export const getSubheaderState = createSelector(
	getFetchState,
	(state) => getVisibleStateById(state, subheaders.tasksOverview),
	(fetchState, subheaderOpen) => {
		const customFilter = pathOr(false, ['queryParams', 'customFilter'], fetchState.lastRequest);
		return subheaderOpen && fetchState.loaded && customFilter;
	},
);

const filterTaskTypeList = (taskTypeList, quickFilterState, taskTypesCodelist) => {
	const { taskIds, infoIds } = getTaskTypesIds(taskTypesCodelist);

	return taskTypeList.filter((item) => {
		if (quickFilterState === QUICK_FILTER_STATES.tasks) {
			return includes(item.taskTypeId.toString(), taskIds);
		} else if (quickFilterState === QUICK_FILTER_STATES.info) {
			return includes(item.taskTypeId.toString(), infoIds);
		} else {
			return true;
		}
	});
};

export const getTasksList = createSelector(
	getTaskTypeList,
	getQuickFilterState,
	getCodelistByName(codelists.taskTypes),
	getSubheaderState,
	(taskTypeList, quickFilterState, taskTypesCodelist, subheaderState) => {
		return subheaderState ? taskTypeList : filterTaskTypeList(taskTypeList, quickFilterState, taskTypesCodelist);
	},
);

export const getProgress = compose(prop('progress'), getRoot);
